import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { COLORS } from "../../../constants";

const Dropdown = ({
                      loading,
                      disabled,
                      value,
                      onChange,
                      options,
                      label,
                      darkMode,
                  }) => {
    const selectedOption = options?.find((option) => option.value === value) ?? null;

    return (
        <Autocomplete
            loading={loading}
            disabled={disabled}
            value={selectedOption}
            onChange={(event, newValue) => onChange(event, newValue ? newValue.value : null)}
            options={options ?? []}
            getOptionLabel={(option) => option?.label ?? ""}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ style: {} }}
                    InputProps={{
                        ...params.InputProps,
                        style: { color: darkMode ? "#ffffff" : null },
                        startAdornment: params.InputProps.startAdornment,
                        endAdornment: params.InputProps.endAdornment,
                    }}
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            backgroundColor: COLORS.white,
                            height: 50,
                            borderRadius: "2px",
                            fontFamily: "Rubik",

                            "& fieldset": {
                                borderWidth: "2px",
                            },
                            "&:hover fieldset": {
                                borderColor: darkMode ? "#ffffff" : null,
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: darkMode ? "#ffffff" : null,
                            },
                        },
                        "& .MuiInputLabel-outlined": {
                            transform: "translate(14px, 50%)",

                            "&.MuiInputLabel-shrink": {
                                transform: "translate(14px, -6px) scale(0.75)",
                            },
                        },
                        "& .MuiSvgIcon-root": {
                            color: darkMode ? "#ffffff" : null,
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                            color: darkMode ? "#ffffff" : null,
                        },
                    }}
                />
            )}
            clearOnEscape
            isOptionEqualToValue={(o, v) => {
                if (!o || !v) return false;
                return o.value === v.value;
            }}
            sx={{
                "& .MuiAutocomplete-option": {
                    fontSize: "0.2rem",
                },
            }}
        />
    );
};

export default Dropdown;